import * as _ from 'underscore';
import * as moment_ from 'moment';
import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '@app/common/app-config.service';

const moment = moment_;

@Pipe({
  name: 'verifiedTimer'
})
export class VerifiedTimerPipe implements PipeTransform {
  constructor(private appConfigService: AppConfigService) {}

  transform(verifiedDateTime, status): string {
    let timeDiff = '';
    if (verifiedDateTime && _.contains(['Verified', 'Dictated', 'Transcribed'], status)) {
      const mins = moment
        .duration(
          moment(this.appConfigService.getCurrentSysDateTime(), 'YYYY-MM-DD HH:mm:ss.SSS').diff(
            moment(verifiedDateTime, 'YYYY-MM-DD HH:mm:ss.SSS')
          )
        )
        .asMinutes();
      timeDiff =
        mins > 0
          ? mins < 6000
            ? ('0' + Math.floor(mins / 60)).slice(-2) + ':' + ('0' + Math.floor(mins % 60)).slice(-2)
            : '99+'
          : '00:00';
    }
    return timeDiff;
  }
}
